var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "012.\xED\x8F\xB4\xEB\x8D\x94,\xEC\xA0\x80\xEC\x9E\xA5\xEC\x86\x8C 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.2338 16.9997L31.9337 21.6997L33.3145 23.0805C33.6896 23.4556 34.1983 23.6663 34.7288 23.6663H66.667C67.7716 23.6663 68.667 24.5618 68.667 25.6663V60.9997C68.667 62.1042 67.7716 62.9997 66.667 62.9997H12.3337C11.2291 62.9997 10.3337 62.1042 10.3337 60.9997V18.9997C10.3337 17.8951 11.2291 16.9997 12.3337 16.9997H27.2338ZM27.2338 13.333H13.3337C9.66699 13.333 6.66699 16.333 6.66699 19.9997V59.9997C6.66699 63.6663 9.66699 66.6663 13.3337 66.6663H66.667C70.3337 66.6663 73.3337 63.6663 73.3337 59.9997V26.6663C73.3337 22.9997 70.3337 19.9997 66.667 19.9997H36.667L31.9671 15.2997C30.7004 14.033 29.0338 13.333 27.2672 13.333H27.2338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M69 36H10V40H69V36Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folderIcon.648dae21dac455922a7dfcd8a104b4cf.svg";
export { ForwardRef as ReactComponent };